import React, { useEffect } from 'react';
import Footer from './Footer';
import Head from './Header';
function Lavoro() {
    /*const [nome, setNome] = useState("")
    const [cognome, setCognome] = useState("")
    const [professione, setProfessione] = useState("")
    const [mail, setMail] = useState("")
    const [telefono, setTelefono] = useState("")
    const [curriculum, setCurriculum] = useState("")*/

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, []);

    /*const submitApply = (o) => {
  
        fetch(document.apiURL + '/sendmail', {
            method: 'POST',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "from": "noreply@futuracare.it",
                "to": "candidature@futuracare.it",
                "subject": `Richiesta per ${professione}`,
                "html": `<p>Richiesta per ${professione}
                Nome: ${nome}, Cognome: ${cognome}
                Tel.: ${telefono}
                Mail: ${mail}</p>`,
                "attachments": []
            })
        })
            .then(response => response.json())
            .then(response => {
           
            })
    }*/

    return (<>
        <Head></Head>
        <div style={{ height: '100vh' }}>
            <div className="main-header">
                <div className="container">
                    <div className="flex">
                        <div className="f1">
                            <div className="col sm-mid">
                                <h2>Sei un professionista e ti piacerebbe collaborare con noi?
                                    <br></br>
                                    Entra a far parte della famiglia di Futura Care.</h2>
                                <span className="blue-line">
                                </span>
                                <p className="margin">
                                    Futura Care presta estrema attenzione al processo di selezione per reclutare personale altamente qualificato nel rispetto dei principi e dei valori di trasparenza e professionalità.
                                </p>
                                <p className="margin">Le tue competenze e la tua disponibilità potranno aiutarci a raggiungere i nostri obiettivi, non esitare ad inviare il tuo curriculum vitae!</p>
                                <p className="margin"><a href="mailto:candidature@futuracare.it">Candidati</a> ed inizia a lavorare con noi.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*<div className="main-header">
                <div className="container">
                    <div className="col sm-mid " style={{ marginTop: '2em', width: '100%' }}>
                        <h4 style={{ marginBottom: '10px' }}>Candidati</h4>
                        <span className="blue-line" style={{ width: '100%', marginBottom: '10px' }}>
                        </span>
                        <input value={nome} onChange={(e) => setNome(e.target.value)} name="name" type="text" className="input" style={{ width: '50%' }} placeholder="Nome" />
                        <input value={cognome} onChange={(e) => setCognome(e.target.value)} type="name" className="input" style={{ width: '50%', marginTop: '10px' }} placeholder="Cognome" />
                        <input value={professione} onChange={(e) => setProfessione(e.target.value)} type="text" className="input" style={{ width: '50%', marginTop: '10px' }} placeholder="Professione" />
                        <input value={mail} onChange={(e) => setMail(e.target.value)} type="mail" className="input" style={{ width: '50%', marginTop: '10px' }} placeholder="Mail" />
                        <input value={telefono} onChange={(e) => setTelefono(e.target.value)} type="tel" className="input" style={{ width: '50%', marginTop: '10px' }} placeholder="Telefono" />
                        <input value={curriculum} onChange={(e) => setCurriculum(e.target.value)} type="file" className="input" style={{ width: '50%', marginTop: '10px' }} placeholder="Curriculum" />
                        <button onClick={() => submitApply({nome, cognome, professione, mail, telefono, curriculum})} className="button margin-top-min" style={{ marginTop: '20px', width: '50%' }}>Invia</button>
                    </div>
                </div>
            </div>*/}
        </div>
        <Footer></Footer>  </>
    );
}


export default Lavoro;